import React, {} from "react";
import { colors, css, fonts, glyphs } from "../../../Styles";
import { useTranslation } from "react-i18next";
import { WaitAnimation } from "../../BaseComponents";
import { TFunction } from "i18next";
import { getFeedMotorConfig } from "./esfStationCore";

/* eslint-disable */
export enum EsfStationSizes {
  small = "small",
  normal = "normal",
}
/* eslint-enable */
interface EsfStationProps {
  size?: EsfStationSizes;
  pins?: {
    feedMotor?: number;
    gateMotor?: number;
    components?: boolean;
  };
}

export function EsfStationCoreWalkIn({ size = EsfStationSizes.normal, pins }: EsfStationProps) {
  const { t } = useTranslation();
  const feedMotorConfig = getFeedMotorConfig(t);

  const feedMotorText = pins?.feedMotor && feedMotorConfig[Number(pins.feedMotor)]?.label
  const feedMotorColor = pins?.feedMotor && feedMotorConfig[Number(pins.feedMotor)]?.color

  // ViewBox dimensions
  const minY = size === EsfStationSizes.normal ? 18.7146 : 0
  const minX = 0;
  const maxY = 157.31
  const maxWidth = size === EsfStationSizes.normal ? 250 : 190;
  const maxHeight = maxY - minY;
  const smallOffsetX = size === EsfStationSizes.normal ? 0 : -40;
  
  // Size and aspect ratio
  let sizeValue: number;
  switch (size) {
  case EsfStationSizes.small:
      sizeValue = 160;
    break;
  case EsfStationSizes.normal:
    default:
      sizeValue = 600;
    break;
  }
  
  const aspectRatio = maxHeight / maxWidth;

  const width = sizeValue;
  const height = width * aspectRatio;

  // Text font sizes
  const baseSvgWidth = width / maxWidth;
  const scaledPrimaryFontSize = 14 / baseSvgWidth;
  const scaledSecondaryFontSize = 12 / baseSvgWidth;

  const animation = `
    @keyframes pulseOpacity {
      0% { opacity: 0.2; }
      25% { opacity: 1; }
      50% { opacity: 1; }
      75% { opacity: 1; }
      100% { opacity: 0.2; }
    }
  `

  return (<>
    <style>{animation}</style>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`${minX} ${minY} ${maxWidth} ${maxHeight}`} fill="none" style={{ overflow: "visible" }}>
      <g transform={`translate(${smallOffsetX}, 0)`}>

        {/* Walls */}
        <path // Back wall
          d="M47.7 64H158.1C160.8 64 163.2 65.64 164.22 68.15L193.65 140.66C194.15 141.91 193.23 143.28 191.88 143.28H47.7C46.66 143.28 45.81 142.43 45.81 141.39V65.89C45.81 64.85 46.66 64 47.7 64Z"
          fill={colors.greyLightSecondary}
          stroke={colors.greyTertiary}
          strokeWidth={ size === EsfStationSizes.normal ? 0.8 : 1.4}
        />
        <path // Front wall
          d="M42.04 143.5L62.7 157.31H207.92C209.58 157.31 210.73 155.64 210.14 154.08L182.72 82.21C181.67 79.44 179.01 77.62 176.06 77.62H62.7L44.61 66.02C43.02 65 41 66.11 41 67.99V141.73C41 142.52 41.39 143.22 42.04 143.5Z"
          fill={colors.graphBlueTen}
          stroke={colors.greyDarkSecondary}
          strokeWidth={size === EsfStationSizes.normal ? 0.8 : 1.4}
        />
        <line // Front wall vertical line
          x1="63.668" y1="83.4722" x2="63.668" y2="150.697"
          stroke={colors.graphBlueEight}
        />
            
        {/* Feed container */}
        {size === EsfStationSizes.normal ? (<>
          <path // Upper feed container
            d="M65.3713 24.1716L60.547 25.4704C58.364 26.0581 56.8469 28.0377 56.8469 30.2985V44.761C56.8469 45.4784 57.0013 46.1874 57.2995 46.8398L61.1502 55.2632C61.9638 57.0429 63.7408 58.1844 65.6976 58.1844H84.622C87.3834 58.1844 89.622 55.9459 89.622 53.1844V28.9996C89.622 26.2382 87.3834 23.9996 84.622 23.9996H66.6711C66.2322 23.9996 65.7951 24.0574 65.3713 24.1716Z"
            fill="#4D6786"
            stroke="#3B4143"
            strokeWidth={0.8}
          />
          <path // Lower feed container
            d="M84.622 50.0788H70.2792C68.5074 50.0788 66.8679 51.0165 65.9696 52.5437L61.0614 60.8875C60.6094 61.6559 60.3711 62.5311 60.3711 63.4226V65.1717C60.3711 67.1393 61.525 68.9239 63.3193 69.7313L66.4409 71.136C67.086 71.4263 67.7853 71.5764 68.4927 71.5764H84.622C87.3834 71.5764 89.622 69.3379 89.622 66.5764V55.0788C89.622 52.3173 87.3834 50.0788 84.622 50.0788Z"
            fill="#4D6786"
            stroke="#3B4143"
            strokeWidth={0.8}
          />
          <path // Upper feed container vertical line
            d="M66.7147 27.1714V46.5546"
            stroke="#5B7691"
          />
          <path // Lower feed container vertical line
            d="M66.7147 56.4224L66.7147 68.4047"
            stroke="#5B7691"
          />
        </>) : (<>
          <path // Upper feed container
            d="M64.4974 1.17192L55.5712 3.57507C53.3882 4.16282 51.8711 6.14235 51.8711 8.40316V31.5424C51.8711 32.2598 52.0255 32.9688 52.3237 33.6212L58.6987 47.5662C59.5123 49.3458 61.2892 50.4873 63.246 50.4873H94.3185C97.08 50.4873 99.3185 48.2488 99.3185 45.4873V6C99.3185 3.23858 97.08 1 94.3185 1H65.7973C65.3583 1 64.9213 1.0578 64.4974 1.17192Z"          fill={colors.graphBlueTen}
            stroke={colors.greyDarkSecondary}
            strokeWidth={1.4}
          />
          <path // Lower feed container
            d="M94.3456 38.7554H70.0635C68.2916 38.7554 66.6522 39.6931 65.7538 41.2202L57.6903 54.9279C57.2383 55.6963 57 56.5715 57 57.463V62.0517C57 64.0193 58.1539 65.8039 59.9482 66.6114L66.2251 69.4359C66.8702 69.7262 67.5695 69.8763 68.2769 69.8763H94.3456C97.107 69.8763 99.3456 67.6377 99.3456 64.8763V43.7554C99.3456 40.9939 97.107 38.7554 94.3456 38.7554Z"          fill={colors.graphBlueTen}
            stroke={colors.greyDarkSecondary}
            strokeWidth={1.4}
          />
          <path // Upper feed container vertical line
            d="M66.1836 5.59131V33.6511"
            stroke={colors.graphBlueEight}
          />
          <path // Lower feed container vertical line
            d="M66.1836 47.9375L66.1836 65.2836"
            stroke={colors.graphBlueEight}
          />
        </>)}

        {/* Pins */}
        {size === EsfStationSizes.normal ? (<>
          {pins&&pins.components ? ( <>
            <path // Feed Motor Pin
              d={`M77.4663 29.4873L77.4663 18.7146`}
              stroke={colors.graphBlueSeven}
              strokeWidth="1"
            />
            <path // Feed Motor Pin
              d={`M0 19 H${maxWidth}`}
              stroke={colors.graphBlueSeven}
              strokeWidth="1"
            />
            <mask id="walk-in-mask3_198_402" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="72" y="26" width="11" height="11">
              <path
                transform="translate(77.4663, 31.614) scale(1.2) translate(-77.4663, -31.614)"
                d="M72.6784 36.374L72.6784 26.854L75.8517 26.854L75.8517 28.758L79.0251 28.758L79.0251 26.854L82.1984 26.854L82.1984 36.374L75.8517 36.374L72.6784 36.374Z"
                fill={colors.graphBlueSeven}
              />
            </mask>
            <g mask="url(#walk-in-mask3_198_402)">
              <path
                transform="translate(77.4663, 31.6143) scale(1) translate(-77.4663, -31.6143)"
                d="M73.5631 31.6143C73.5631 29.4741 75.2979 27.7385 77.4381 27.7383C79.5784 27.7383 81.314 29.474 81.314 31.6143C81.3139 33.7545 79.5782 35.4893 77.4381 35.4893C75.298 35.4891 73.5632 33.7543 73.5631 31.6143Z"
                stroke={colors.graphBlueSeven}
                strokeWidth="0.5"
                style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
              />
            </g>
            <ellipse  cx="77.4663" cy="31.6121" rx="2.22133" ry="2.22134" transform="rotate(-90 77.4663 31.6121)" fill={colors.graphBlueSeven} />
          </>) : (<></>)}
        </>) : (<>
          <path // Feed Motor Pin
            d="M79.7383 20.2209H93.4212L106.677 6.30225H224"
            stroke="#728AA9"
            strokeWidth="2"
          />
          <text x={"110"} y={"27"} textAnchor="start" fontSize={scaledPrimaryFontSize} style={{ ...fonts.header }} fill={colors.greyDarkPrimary}>{t("esfWalkThroughPages.sections.feedMotor", {defaultValue: "feed motor"})}</text>
          {feedMotorText ? <circle cx={"114"} cy={"38"} r={3} fill={colors.greyDarkPrimary} /> : undefined}
          <text x={feedMotorText ? "123" : "110"} y={"43"} textAnchor="start" style={{ ...(feedMotorText ? undefined : css.emptyPen), ...fonts.paragraph, fontSize: scaledSecondaryFontSize, opacity: feedMotorText ? "1" : "0.5" }} fill={pins?.feedMotor ? `${feedMotorColor}` : colors.greyDarkPrimary}>{feedMotorText ?? t("noData", { defaultValue: "no data" })}</text>
          <mask id="walk-in-mask0_187_130" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="69" y="10" width="21" height="21">
            <path
              transform="translate(79.5068, 20.2207) scale(1.2) translate(-44.5068, -20.2207)"
              d="M34.5625 10.2793H54.4462V16.9072H50.4694V23.5351H54.4462V30.163H34.5625V16.9072V10.2793Z"
              fill="#728AA9"
            />
          </mask>
          <g mask="url(#walk-in-mask0_187_130)">
            <path
              transform="translate(79.5068, 20.2207) scale(1.2) translate(-44.5068, -20.2207)"
              d="M44.5068 12.1045C48.9893 12.1045 52.623 15.7382 52.623 20.2207C52.623 24.7032 48.9893 28.3369 44.5068 28.3369C40.0244 28.3369 36.3906 24.7032 36.3906 20.2207C36.3907 15.7383 40.0244 12.1045 44.5068 12.1045Z"
              stroke={colors.graphBlueSeven}
              style={{ animation: `pulseOpacity 2s ease-in-out infinite` }}
            />
          </g>
          <ellipse cx="79.5067" cy="20.2211" rx="4.63952" ry="4.63953" fill="#728AA9" />
        </>)}
      </g>
    </svg>
  </>);
}